import {
  Component, OnInit, Input, SimpleChanges, SimpleChange, OnChanges, ChangeDetectorRef,
  Output, EventEmitter, OnDestroy, ViewRef, HostListener,
  ViewEncapsulation
} from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Question } from 'src/app/model/question';
import { RadioButtonGroupConfig } from 'src/app/model/radio-button/radio-button-group';
import { RadioButton } from 'src/app/model/radio-button/radio-button';
import { UtilService, MEDICAL_UW_HO_URL, AnalyticsService } from '../../shared';
import { LifeStyleQuestion } from 'src/app/pages/medical-underwriting/model/lifestyle.model';
import { UtilityServiceForMedicalService } from 'src/app/pages/medical-underwriting/services/utility-service';
import {
  MedicationQuestionStoreModel, EmitterToCtlTypeModel,
  AccordQuestionStoreModel
} from 'src/app/pages/medical-underwriting/model/mcUserJourney.model';
import { InvokeFunctionExpr } from '@angular/compiler';
import { RangeValidationConfig } from 'src/app/model/rangeValidation.model';
import { DeviceDimensionsService } from 'src/app/shared/utilities/functionality/device-dimensions.service';
import { ConfigLoaderService } from 'src/app/shared/services/api-services/configLoader.service';
import { DayMonthYearDropdownComponent } from '../day-month-year-dropdown/day-month-year-dropdown.component';
import { DateInputComponent } from '../../form-elements/date-input/date-input.component';
import { QuestionRadioButtonComponent } from '../../form-elements/question-radio-button/question-radio-button.component';
import { ToolTipNotificationComponent } from '../../form-elements/tool-tip-notification/tool-tip-notification.component';
import { YellowTagComponent } from '../yellow-tag/yellow-tag.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-question',
    templateUrl: './question.component.html',
    styleUrls: ['./question.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [ReactiveFormsModule, NgClass, YellowTagComponent, ToolTipNotificationComponent, QuestionRadioButtonComponent, DateInputComponent, DayMonthYearDropdownComponent]
})
export class QuestionComponent implements OnInit, OnChanges, OnDestroy {

  @Input() isButtonAlignToBeChanged = false;
  @Input() questionConfig: Question;
  @Input() givenQuestion: LifeStyleQuestion;
  @Input() childId: string;
  @Input() parent: UntypedFormGroup;
  @Input() questiontextRequired = true;
  @Input() controlName: string;
  @Output() valueChange = new EventEmitter();
  @Output() toggleChange = new EventEmitter();
  @Output() editModelHandler: EventEmitter<any> = new EventEmitter();
  @Input() productCode: string;
  @Input() controllerData;
  @Input() isdateReq = false;
  @Output() dateInputHandler = new EventEmitter();
  @Input() formControlName: string;
  @Input() accordIndexToAppend: number;
  @Input() indexToAppend: number;
  @Input() objToReferToRetainValueFromTabSquare: MedicationQuestionStoreModel;
  @Input() objToReferForAccord: AccordQuestionStoreModel;
  @Input() editMode: boolean;
  @Input() disable: boolean = false;
  @Input() commencementDateConfigObj: RangeValidationConfig; 
  @Input() startDateAgeRangeConfigObj: RangeValidationConfig;
  @Output() letterpackEmitter = new EventEmitter();
  @Output() letterPackInfoEmitter = new EventEmitter();
  @Output() pensionWiseInfoEmitter = new EventEmitter();
  @Output() riskTaxEmitter = new EventEmitter();
  @Output() riskInflationEmitter = new EventEmitter();
  @Output() riskLongTermCareEmitter = new EventEmitter();
  @Output() riskDebtMgmtEmitter = new EventEmitter();
  @Output() riskOverallReturnEmitter = new EventEmitter();
  @Output() consentEmitter = new EventEmitter();

  @Output() lifetimeAllowanceEmitter = new EventEmitter();
  @Output() pensionCreditEmitter = new EventEmitter();
  @Output() benefitGuaranteedEmitter = new EventEmitter();

  @Output() lumpSumAllowanceEmitter = new EventEmitter()
  @Output() lsaProtectionEmitter = new EventEmitter()
  @Output() displayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() buttonPressed = new EventEmitter(); //added as part of day month year dropdown for playground page
  public radioButtonGroupConfig: RadioButtonGroupConfig;
  public questionInfo = '';
  public questionCode = '';
  public questionInfoClass = '';
  defaultStyle: boolean;
  applyStyle: boolean;
  lifestyleClass: boolean;
  subscription: any;
  domId: string;
  screenName;
  deviceType: any;
  displayTooltipAlert = false;
  constructor(public router: Router,
              private cdRef: ChangeDetectorRef,
              private utilService: UtilService,
              private fb: UntypedFormBuilder, 
              private utilityServiceForMedicalService: UtilityServiceForMedicalService,
              private analyticsService: AnalyticsService,
              private deviceDimensionsService: DeviceDimensionsService,
              private configLoaderService: ConfigLoaderService) {
  }

  ngOnInit() {
    
    this.detectScreenSize();
    if (this.givenQuestion) {
      if (this.objToReferForAccord) {
        this.givenQuestion.responseValueByUser = this.utilityServiceForMedicalService.getResponseValueFromRefObj(this.objToReferForAccord, this.givenQuestion.id, this.accordIndexToAppend);
      }
      this.domId = this.utilityServiceForMedicalService.getDomId(this.givenQuestion.id, this.accordIndexToAppend, this.indexToAppend);
      this.controlName = this.utilityServiceForMedicalService.getControlName(this.givenQuestion.id, this.accordIndexToAppend);
      if (!this.parent.controls[this.controlName]) {
        this.parent.addControl(this.controlName, this.fb.control(this.givenQuestion.responseValueByUser, this.givenQuestion.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
      }
      else if (this.parent.controls[this.controlName] && this.givenQuestion) {
        this.parent.controls[this.controlName].setValue(this.givenQuestion.responseValueByUser);
      }
      this.setDefaultValueFromAnswer();
    }
    // tslint:disable-next-line:max-line-length
    if (this.parent.controls[this.controlName].value) {
      // tslint:disable-next-line:max-line-length
      if (this.controlName === 'dependantQuestion') {
        this.radioButtonGroupConfig = new RadioButtonGroupConfig(this.questionConfig.questionOptions, this.controlName, this.controlName, this.parent.controls[this.controlName].value, '', this.questionConfig.disabled);
      } else {
        this.radioButtonGroupConfig = new RadioButtonGroupConfig(this.questionConfig.questionOptions, this.controlName, this.controlName, this.parent.controls[this.controlName].value);
      }
    } else {
      // tslint:disable-next-line:max-line-length
      this.radioButtonGroupConfig = new RadioButtonGroupConfig(this.questionConfig.questionOptions, this.controlName, this.controlName, '', '', this.questionConfig.disabled);
    }
    this.updateInfo();
    this.setDefaultStyle();

    this.subscription = this.utilService.emitToggle.subscribe(
      (values) => {
        if (this.parent.controls[this.controlName] && this.parent.controls[this.controlName].value) {
          // tslint:disable-next-line:max-line-length
          this.radioButtonGroupConfig = new RadioButtonGroupConfig(this.questionConfig.questionOptions, this.controlName, this.controlName, this.parent.controls[this.controlName].value, '', this.questionConfig.disabled);
        } else {
          // tslint:disable-next-line:max-line-length
          this.radioButtonGroupConfig = new RadioButtonGroupConfig(this.questionConfig.questionOptions, this.controlName, this.controlName, '', '', this.questionConfig.disabled);
        }
        this.changeDetection();
      }
    );
  }

  @HostListener('window:resize', [])
  public onResize() {
    this.detectScreenSize();
  }
  private detectScreenSize() {
    this.deviceType=this.deviceDimensionsService.onResize('$event');
  }
  
  alertTooltipPrimaryBtnClick() {
    this.displayTooltipAlert = false;
  }

  displayMobileTooltipReceiver(){
    this.displayMobileTooltipEmitter.emit();
  }
  
  setDefaultValueFromAnswer() {
    if (this.givenQuestion && this.givenQuestion.responseValueByUser) {
      this.toggleContainer(this.givenQuestion.responseValueByUser, false, true);
    }
  }

  onBlurRadioButton() {
    if(this.parent.get(this.controlName)) {
      this.parent.get(this.controlName).markAsTouched();      
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.questionConfig) {
      const config: SimpleChange = changes.questionConfig;
      if (this.parent.controls[this.controlName] &&
        this.parent.controls[this.controlName].value) {
        // tslint:disable-next-line:max-line-length
        this.radioButtonGroupConfig = new RadioButtonGroupConfig(config.currentValue.questionOptions, this.controlName, this.controlName, this.parent.controls[this.controlName].value, '', this.questionConfig.disabled);
      } else {
        // tslint:disable-next-line:max-line-length
        this.radioButtonGroupConfig = new RadioButtonGroupConfig(config.currentValue.questionOptions, this.controlName, this.controlName, '', '', this.questionConfig.disabled);
      }

      this.updateInfo();
    } else {
      // tslint:disable-next-line:max-line-length
      if (this.parent.controls[this.controlName].value) {
        // tslint:disable-next-line:max-line-length
        this.radioButtonGroupConfig = new RadioButtonGroupConfig(this.questionConfig.questionOptions, this.controlName, this.controlName, this.parent.controls[this.controlName].value, '', this.questionConfig.disabled);
      } else {
        // tslint:disable-next-line:max-line-length
        this.radioButtonGroupConfig = new RadioButtonGroupConfig(this.questionConfig.questionOptions, this.controlName, this.controlName, '', '', this.questionConfig.disabled);
      }
      if (changes.parent && changes.parent.currentValue.controls['ProductType'] &&
        changes.parent.currentValue.controls['ProductType'] !== 'C'
      ) {
        this.updateInfo();
      }
    }
  }

  toggleContainer(val: string, resetOption: boolean, onPageLoad?: boolean) {
    if (this.editMode && !onPageLoad) { // if (this.editMode && !onPageLoad) {
      this.subscription = this.utilService.updateEditForm.subscribe(res => {
        if (res && res.screen === 'question') {
          this.editMode = false;
          this.toggleContainer(res.value, res.reset);
        }
      });
      const payload = {
        value: val,
        reset: resetOption,
        screen: 'question'
      };
      this.editModelHandler.emit(payload);
    } else {
      this.parent.controls[this.controlName].setValue(val);
      this.radioButtonGroupConfig.setValue(val);
      this.updateInfo();
      if (this.givenQuestion) {
        setTimeout(() => {
          this.toggleChange.emit(new EmitterToCtlTypeModel(val, resetOption,
            this.objToReferToRetainValueFromTabSquare, this.accordIndexToAppend, this.objToReferForAccord));
        }, 300);
      } else {
        this.setLsaDataforMIUsers(val);
        this.toggleChange.emit(val);
      }
      this.prepareQuestionWithSelectedResponse(val);
    }
  }

  prepareQuestionWithSelectedResponse(val: string) {
    if (this.givenQuestion) {
      this.givenQuestion.responseValueByUser = val;
    }
  }

  private updateInfo() {
    if (this.parent.controls[this.controlName] &&
      this.parent.controls[this.controlName].value) {
      const selectedOption: RadioButton = this.questionConfig.questionOptions.filter(btnData => {
        return btnData.code === this.parent.controls[this.controlName].value;
      })[0];
      if (selectedOption) {
        this.questionInfo = selectedOption.infoText;
        this.questionCode = selectedOption.code;
        this.questionInfoClass = selectedOption.infoClass;
        if (this.defaultStyle) {
          this.buttonPressed.emit();//added as part of day month year dropdown for playground page
          this.valueChange.emit(selectedOption);
        }
      }
    }
  }
  setDefaultStyle = () => {
    // tslint:disable-next-line:max-line-length
    if (this.router.url === '/quote/your-product-options' || this.router.url === '/home/your-dependant' || this.router.url === '/home/your-personal-details'
    ) {
      this.defaultStyle = true;
      this.applyStyle = false;
    } else if (this.router.url === '/apply/your-pension-savings') {
      this.defaultStyle = true;
      this.applyStyle = true;
    } else if (this.router.url === '/home/lifestyle' ||
      this.router.url.includes(MEDICAL_UW_HO_URL.annuitant.lifestyle) ||
      this.router.url === '/home/dependant-lifestyle' ||
      this.router.url === MEDICAL_UW_HO_URL.dependant.dependantLifestyle ||
      this.router.url === '/home/medical-condition-questionnaire' ||
      this.router.url === MEDICAL_UW_HO_URL.annuitant.DMC ||
      this.router.url.includes('/home/medical-condition-questionnaire') ||
      this.router.url.includes(MEDICAL_UW_HO_URL.annuitant.DMC) ||
      this.router.url.includes('/home/dependant-medical-condition-questionnaire') ||
      this.router.url.includes(MEDICAL_UW_HO_URL.dependant.dependantDMC)) {
      this.defaultStyle = false;
      this.applyStyle = false;
      this.lifestyleClass = true;
    } else {
      this.defaultStyle = false;
      this.applyStyle = false;
    }
  }
  checkDataChange(dateVal) {
    this.dateInputHandler.emit(dateVal);
  }
  changeDetection = () => {
    setTimeout(() => {
      if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
        this.cdRef.detectChanges();
      }
    });
  }
  showMandatoryError = (): string => {
    let errorMessage = 'Please select ';
    if (this.questionConfig) {
      if (this.controlName === 'ltaProtection') {
        errorMessage = this.questionConfig.validationMsg;
      } else {
        this.questionConfig.questionOptions.forEach((question, index) => {
          if (index === this.questionConfig.questionOptions.length - 2) {
            errorMessage += question.label + ' or ';
          } else {
            errorMessage += question.label +
              ((index !== this.questionConfig.questionOptions.length - 1) ? ' , ' : '');
          }
        });
      }
    }
    return errorMessage;
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    
    if (this.parent.controls[this.controlName]) {
      this.parent.controls[this.controlName].markAsUntouched();
      this.parent.controls[this.controlName].setErrors(null);
    }
  }
    /** For web tracking */
    getCurrentScreenURL() {
      this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
  
      return this.screenName;
    }

    lifestyleInfoReceiver(value: LifeStyleQuestion) {
      if (value && this.utilityServiceForMedicalService.isPartOfWA(value.questionText)) {
        this.analyticsService.eventTrack({ type: 'Question', name: value.questionText, pageID: this.getCurrentScreenURL() });
      }
    }
  
    letterPackInfoIcon(val) {
      if(this.controlName === 'letterPack') {
        this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
      }
    }
    pensionWiseInfoReceiver(val) {
      if(this.controlName === 'pensionGuidance') {
        this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
      }
    }
    UKResidentInfoReceiver(val) {
      if(this.controlName === 'ukaddressIndicator') {
        this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
      }
    }
    dependentContinueToPayInfoReceiver(val) {
      if(this.controlName === 'dependantQuestion') {
        this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
      }
    }
    riskTaxReceiver(val) {
      this.riskTaxEmitter.emit(val);
    }
    riskInflationReceiver(val) {
      this.riskInflationEmitter.emit(val);
    }
    riskLongTermCareReceiver(val) {
      this.riskLongTermCareEmitter.emit(val);
    }
    riskDebtMgmtReceiver(val) {
      this.riskDebtMgmtEmitter.emit(val);
    }
    riskOverallReturnReceiver(val) {
      this.riskOverallReturnEmitter.emit(val);
    }
    consentReceiver(val) {
      this.consentEmitter.emit(val);
    }
    lifetimeAllowanceReceiver(val) {
      this.lifetimeAllowanceEmitter.emit(val);
    }
    pensionCreditReceiver(val) {
      this.pensionCreditEmitter.emit(val);
    }
    benefitGuaranteedReceiver(val) {
      this.benefitGuaranteedEmitter.emit(val);
    }

    lumpSumAllowanceReceiver(val){
      this.lumpSumAllowanceEmitter.emit(val)
    }

    lsaProtectionReceiver(val){
      this.lsaProtectionEmitter.emit(val)
    }
  setLsaDataforMIUsers(code: string) {
    const val = (this.questionConfig.questionOptions.find(obj => obj.code === code)).label;
    this.analyticsService.eventTrack({ type: 'ButtonClick', name: this.questionConfig.questionStatement, pageID: this.getCurrentScreenURL(), details: val });
  }
}
